import { render, staticRenderFns } from "./campaignPostsByStatus.vue?vue&type=template&id=13888ff6&"
import script from "./campaignPostsByStatus.vue?vue&type=script&lang=js&"
export * from "./campaignPostsByStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports